import API from "./axios";

// REGISTER

export const registerUser = async (
  payload,
  orgId
) => {
  const response = await API.post(
    `/patientreg/register`,
    payload
  );

  return response.data;
};

// VERIFY REGISTRATION OTP

// export const verifyOtp = async (payload) => {
//   const response = await API.post(
//     "/patientreg/verify",
//     payload
//   );

//   return response.message
// ;
// };

export const verifyOtp = async (payload) => {
  try {
    const response = await API.post("/patientreg/verify", payload);
    return response.data;
  } catch (err) {
    // Re-throw with the actual backend message
    const message = err?.response?.data?.message || "Verification failed";
    throw new Error(message);
  }
};
// PASSWORD SETUP

export const setupPassword = async (payload) => {
  const response = await API.post(
    "/patientreg/password",
    payload
  );

  return response.data;
};

// SEND QUICK OTP

export const sendQuickOtp = async (payload) => {
  try {
  const response = await API.post(
    "/patientreg/send-otp",
    payload
  );

  return response.data;
}
  catch (err) {
  const message = err?.response?.data?.message || "OTP sending failed";
    throw new Error(message);
  }
};

// QUICK REGISTER

export const quickRegister = async (payload) => {
   try {
  const response = await API.post(
    "/patientreg/quick-register",
    payload
  );
  return response.data;

   } catch (err) {
  const message = err?.response?.data?.message || "Verification failed";
    throw new Error(message);
};}

// LOGIN WITH PASSWORD

export const loginWithPassword = async (
  payload
) => {
  const response = await API.post(
    "/patientreg/login/password",
    payload
  );

  return response.data;
};

// SEND LOGIN OTP

export const loginOtpSend = async (payload) => {
  const response = await API.post(
    "/patientreg/login/otp/send",
    payload
  );

  return response.data;
};

// VERIFY LOGIN OTP

export const verifyLoginOtp = async (
  payload
) => {
  try{
  const response = await API.post(
    "/patientreg/login/otp/verify",
    payload
  );

  return response.data;
}catch (err) {
  const message = err?.response?.data?.message || "OTP verification failed";
    throw new Error(message);
}
};

// REFRESH TOKEN

export const refreshTokenApi = async (
  payload
) => {
  const response = await API.post(
    "/patientreg/login/refresh",
    payload
  );

  return response.data;
};

// CHANGE PASSWORD

export const changePassword = async (
  payload
) => {
  const response = await API.post(
    "/patientreg/change-password",
    payload
  );

  return response.data;
};